(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bw-shelf"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bw-shelf').forEach((shelf) => {
    const track = shelf.querySelector('.bw-shelf__track');
    const nav = shelf.querySelector('.bw-shelf__nav');
    if (!track || !nav) return;
    const [prev, next] = nav.querySelectorAll('.bw-shelf__arrow');
    const update = () => {
      const overflow = track.scrollWidth - track.clientWidth > 4;
      nav.hidden = !overflow;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    };
    nav.querySelectorAll('.bw-shelf__arrow').forEach((btn) => {
      btn.addEventListener('click', () => {
        const card = track.querySelector('.bw-shelf__card');
        const step = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
        track.scrollBy({ left: step * Number(btn.dataset.dir), behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-sticky-buy"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bar = document.querySelector('.bw-sticky-buy');
    if (!bar) return;
    const anchor = document.querySelector('.bw-notify') || document.querySelector('.buy-buttons-block');
    const target = document.querySelector(bar.dataset.target) || anchor;
    const show = (on) => {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', String(!on));
      bar.querySelector('button').tabIndex = on ? 0 : -1;
    };
    if (anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        show(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(anchor);
    }
    bar.querySelector('button').addEventListener('click', () => {
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const field = target.querySelector('input[type="email"]');
      if (field) setTimeout(() => field.focus({ preventScroll: true }), 500);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
